"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductionV1 = void 0;
var ProductionV1 = /** @class */ (function () {
    function ProductionV1(data) {
        this.TaskTypes = data.TaskTypes;
        this.TaskTypeToItemType = data.TaskTypeToItemType;
    }
    ProductionV1.prototype.getTaskTypes = function () {
        return this.TaskTypes;
    };
    ProductionV1.prototype.getTaskTypeToItemType = function () {
        return this.TaskTypeToItemType;
    };
    return ProductionV1;
}());
exports.ProductionV1 = ProductionV1;
//# sourceMappingURL=production.js.map